/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getTrainings, changeSelectedTrainingType, showModal } from "actions";
import RegisteredTrainings from "components/widgets/training/RegisteredTrainings";
import TargetedTrainings from "components/widgets/training/TargetedTrainings";
import ToBeCompletedTrainings from "components/widgets/training/ToBeCompletedTrainings";
import PendingApprovalTrainings from "components/widgets/training/PendingApprovalTrainings";
import RoleTrainings from "components/widgets/training/RoleTrainings";
import * as Alerts from "components/elements/alerts";
import i18n from "i18next";

class TrainingsList extends Component {
  state = {
    trainingsFetched: false,
    showOptions: false,
    filteredTrainingsData: [],
    filterTerm: "",
    error: null,
    isManager: localStorage.getItem("roles").includes("Manager"),
  };

  componentDidMount() {
    this.fetchTrainings();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.trainings.selectedTrainingType !==
      prevProps.trainings.selectedTrainingType
    ) {
      this.fetchTrainings();
    }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredTrainingsData: this.props.trainings.data.trainings.filter(
          (training) => {
            let children = training.childTrainings?.filter((child) => {
              return child.training.name
                .toLowerCase()
                .includes(this.state.filterTerm.toLowerCase());
            });

            return (
              training.training.name
                .toLowerCase()
                .includes(this.state.filterTerm.toLowerCase()) ||
              training.childTrainings?.includes(children[0])
            );
          }
        ),
      });
    }
  }

  fetchTrainings = () => {
    this.props.getTrainings(
      this.props.trainings
        ? this.props.trainings.selectedTrainingType
        : "registered",
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    this.setState({ error: err.message });
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.setState({
      trainingsFetched: true,
      filteredTrainingsData: this.props.trainings.data.trainings,
    });
  };

  handleTrainingTypeComboToggle = () => {
    let showOptions = this.state.showOptions;
    this.setState({ showOptions: !showOptions });
  };

  closeTrainingTypeCombo = () => {
    this.setState({ showOptions: false });
  };

  handleTrainingTypeSelection = (e) => {
    this.props.changeSelectedTrainingType(e);
    this.setState({ showOptions: false });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  renderError = () => {
    if (this.state.error) {
      return (
        <div style={{ backgroundColor: "white" }}>
          <div style={{ width: "80%", margin: "auto" }}>
            {Alerts.RedAlert({ content: this.state.error })}
          </div>
        </div>
      );
    } else return null;
  };

  renderTrainingTypeOptions = () => {
    if (!this.state.showOptions) {
      return null;
    }
    return (
      <div
        className="custom-options"
        style={{ visibility: "visible", opacity: "1", pointerEvents: "all" }}
      >
        <span
          onClick={() => this.handleTrainingTypeSelection("registered")}
          className="custom-option personalTableType selected"
        >
          <Trans desc="Kayıtlı Eğitimler">10054</Trans>
        </span>
        <span
          onClick={() => this.handleTrainingTypeSelection("toBeCompleted")}
          className="custom-option personalTableType"
        >
          <Trans desc="Tamamlanması Gereken Eğitimler">10055</Trans>
        </span>
        {this.state.isManager ? (
          <span
            onClick={() => this.handleTrainingTypeSelection("pendingApproval")}
            className="custom-option personalTableType"
          >
            <Trans desc="Onay Bekleyen Eğitimler">10056</Trans>
          </span>
        ) : null}
        <span
          onClick={() => this.handleTrainingTypeSelection("targeted")}
          className="custom-option personalTableType"
        >
          <Trans desc="Hedeflenen Pozisyon Eğitimleri">10057</Trans>
        </span>
        <span
          onClick={() => this.handleTrainingTypeSelection("role")}
          className="custom-option personalTableType"
        >
          <Trans desc="Rol Eğitimleri">10552</Trans>
        </span>
      </div>
    );
  };

  renderAndTranslateSelectedTrainingTypeName = () => {
    switch (this.props.trainings.selectedTrainingType) {
      case "registered":
        return <Trans>10054</Trans>; //Kayıtlı Eğitimler
      case "targeted":
        return <Trans>10057</Trans>; //Hedeflenen Pozisyon Eğitimleri
      case "toBeCompleted":
        return <Trans>10055</Trans>; //Tamamlanması Gereken Eğitimler
      case "pendingApproval":
        return <Trans>10056</Trans>; //Onay Bekleyen Eğitimler
      case "role":
        return <Trans>10552</Trans>; //Rol Eğitimleri
      default:
        return <Trans>10054</Trans>; //Kayıtlı Eğitimler
    }
    // return <Trans>{this.props.trainings.selectedTrainingType}</Trans>;
  };

  renderTableToolbar = () => {
    return (
      <div className="row align-items-center py-3 eduTitleArea">
        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 eduTitleTextArea">
          <div className="egitimlerBaslik">
            <Trans desc="Eğitimler">10013</Trans>
          </div>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 offset-md-2 col-lg-6 offset-lg-2">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 tableSearchArea">
              <div className="inner-addon right-addon">
                <span className="iconmford fo-icon-search"></span>
                <input
                  type="text"
                  name="tableSearch"
                  id="tableSearch"
                  className="form-control"
                  placeholder={i18n.t("10053")}
                  onChange={(e) => this.handleFilter(e)}
                  value={this.state.filterTerm}
                />
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 tableCategoryArea">
              <div className="custom-select-wrapper my-ft" id="TableCategory">
                <div className="custom-select">
                  <div
                    style={{ zIndex: 2 }}
                    className="custom-select__trigger"
                    onClick={this.handleTrainingTypeComboToggle}
                    onBlur={this.closeTrainingTypeCombo}
                  >
                    <span>
                      {this.renderAndTranslateSelectedTrainingTypeName()}
                    </span>
                    <span className="icon-icon-table-dropdown"></span>
                  </div>
                  {this.renderTrainingTypeOptions()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderData = () => {
    switch (this.props.trainings.selectedTrainingType) {
      case "registered":
        return (
          <RegisteredTrainings
            data={this.state.filteredTrainingsData}
            employeeCode={this.props.trainings.data.employeeCode}
          />
        );
      case "targeted":
        return <TargetedTrainings data={this.state.filteredTrainingsData} />;
      case "toBeCompleted":
        return (
          <ToBeCompletedTrainings data={this.state.filteredTrainingsData} />
        );
      case "pendingApproval":
        return (
          <PendingApprovalTrainings
            data={this.state.filteredTrainingsData}
            refresh={this.fetchTrainings}
          />
        );
      case "role":
        return <RoleTrainings data={this.state.filteredTrainingsData} />;
      default:
        return <RegisteredTrainings />;
    }
  };

  render() {
    return (
      <>
        {this.renderTableToolbar()}
        <div className="row pb-3">{this.renderData()}</div>
        {this.props.spinner}
        {this.renderError()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    trainings: state.trainings,
    modal: state.modal,
    application: state.application,
  };
};

export default connect(mapStateToProps, {
  getTrainings,
  changeSelectedTrainingType,
  showModal,
})(containsLongRunningProcess(TrainingsList));
